import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const findPageTitle = (pageName: any) => {
  switch (pageName) {
    default:
      return "";
  }
};

export default function TopNavComponent() {
  const [pageTitle, setPageTitle] = useState("");
  const location = useLocation();
  useEffect(() => {
    console.log(location);
    setPageTitle(findPageTitle(location.pathname));
  }, [location]);
  function toggle() {
    const sidebarToggle = document.body.querySelector("#sidebarToggle");
    if (sidebarToggle) {
      console.log("sidebar toggle");
      document.body.classList.toggle("sb-sidenav-toggled");
      localStorage.setItem(
        "sb|sidebar-toggle",
        String(document.body.classList.contains("sb-sidenav-toggled"))
      );
    }
  }
  return (
    <nav className="sb-topnav navbar navbar-expand navbar-dark">
      <a className="pageTitle text-decoration-none">
      Driverman Challenge
       </a>

      <button
        onClick={() => toggle()}
        className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 d-lg-none"
        id="sidebarToggle"
      >
        <i className="fas fa-bars"></i>
      </button>

      <h1 className="pageTitle">{pageTitle}</h1>
      <div className="loggedUser ms-auto me-3 me-lg-4">
        {/* <div className="name"> */}
          <div className="pageTitle text-decoration-none py-2" >Game Admin</div>
          {/* <div className="userSubTitle">Game Admin</div> */}
        {/* </div> */}
        <div className="pic">
          <img src={"/assets/img/snap.png"} alt="snap" />
        </div>
      </div>
    </nav>
  );
}
